import { IHttpApi } from '@cian/http-api/shared';
import {
  fetchApiGeoGeocodeCached,
  IApiGeoGeocodeCachedRequest,
  IApiGeoGeocodeCachedResponse,
  IApiGeoGeocodeCachedResponse200,
  IApiGeoGeocodeCachedResponse400,
  IApiGeoGeocodeCachedResponseError,
} from '../repositories/monolith-cian-realty/unversioned/api-geo-geocode-cached';

import { isResponseContainsKey } from './helpers';

export async function getCachedGeocode(httpApi: IHttpApi, parameters: IApiGeoGeocodeCachedRequest, subdomain?: string) {
  const { response } = await fetchApiGeoGeocodeCached<IApiGeoGeocodeCachedResponse200, IApiGeoGeocodeCachedResponse400>(
    {
      httpApi,
      parameters,
      config: {
        subdomain: subdomain || 'www',
      },
    },
  );

  if (isResponseContainsKey<IApiGeoGeocodeCachedResponseError, IApiGeoGeocodeCachedResponse>(response, 'errors')) {
    throw response;
  }

  return response;
}
